import React, { useEffect, useState } from "react";
import axios from "axios";
import "./TextAdsPage.css";

const TextAdsPage = () => {
  const [ad, setAd] = useState(null);

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://success-blog-app-backend.onrender.com";

  const addView = async (id) => {
    try {
      //  Every load counts as a view
      await axios.post(`${BASE_URL}/api/ads/view/${id}`);
    } catch (err) {
      console.log("View update failed", err);
    }
  };

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ads/all-ads`);

        const ads = res.data.filter(
          (a) => a.adType === "text" && a.views < a.maxViews
        );

        if (!ads.length) return;

        let i = Number(localStorage.getItem("adIndex")) || 0;

        if (i >= ads.length) i = 0;

        const selected = ads[i];

        localStorage.setItem("adIndex", i + 1);

        setAd(selected);

        // 👇 every view counted (no restriction)
        addView(selected._id);
      } catch (err) {
        console.log("Error loading ads", err);
      }
    };

    load();
  }, []);

  if (!ad) return null;

  return (
    <div className="text-ad-wrapper">
      <div
        className="text-ad-box"
        onClick={() => ad.link && window.open(ad.link, "_blank")}
      >
        <p className="text-ad-text">{ad.text}</p>
        <span className="text-ad-click">Click to visit</span>
      </div>
    </div>
  );
};

export default TextAdsPage;